import { Pipe, type PipeTransform } from '@angular/core';

const ISO_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

@Pipe({ name: 'isValidIsoString' })
export class IsValidIsoStringPipe implements PipeTransform {
  transform(value: string): boolean {
    if (!ISO_DATETIME_REGEX.test(value)) {
      return false;
    }

    const date = new Date(value);
    return !Number.isNaN(date.getTime());
  }
}
